var map = {
	"./tyre-default.png": 139,
	"./tyre-green-1.png": 154,
	"./tyre-green-2.png": 276,
	"./tyre-green-3.png": 277,
	"./tyre-green.png": 102,
	"./tyre-high.png": 123,
	"./tyre-low.png": 152,
	"./tyre-middle.png": 138,
	"./tyre-red-1.png": 278,
	"./tyre-red-2.png": 279,
	"./tyre-red-3.png": 280,
	"./tyre-red.png": 125,
	"./tyre-yellow-1.png": 281,
	"./tyre-yellow-2.png": 282,
	"./tyre-yellow-3.png": 283,
	"./tyre-yellow.png": 153
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 358;